export const SUPPORT_EMAIL = "support@clearhealthinc.com";
export const SUPPORT_PHONE = "(888) 918-2522";
